var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWhiteBg = function SvgWhiteBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_1946)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_135_1946",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_135_1946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2094.12 -405.108L1549.97 -272.78L1682.3 271.372L2226.45 139.044L2094.12 -405.108Z",
    fill: "#53B7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.2 90.0997L1550 -272.7L1731.4 -316.8L1819.6 45.9997L1638.2 90.0997Z",
    fill: "#52B2C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.85 658.06L1415.92 1198.96L1956.82 1343.89L2101.75 802.988L1560.85 658.06Z",
    fill: "#95CD45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1975.6 913.8C1968.9 938.7 1943.3 953.5 1918.4 946.8C1893.5 940.1 1878.7 914.5 1885.4 889.6C1892.1 864.7 1917.7 849.9 1942.6 856.6C1967.5 863.4 1982.3 888.9 1975.6 913.8Z",
    fill: "#E4FEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.2 841.4C1698.5 866.3 1672.9 881.1 1648 874.4C1623.1 867.7 1608.3 842.1 1615 817.2C1621.7 792.3 1647.3 777.5 1672.2 784.2C1697 790.9 1711.8 816.5 1705.2 841.4Z",
    fill: "#E4FEE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1928.3 1090.5C1901.6 1190.1 1799.3 1249.2 1699.7 1222.5C1600.1 1195.8 1541 1093.5 1567.7 993.9L1657.9 1018.1C1644.6 1067.9 1674.1 1119.1 1723.9 1132.4C1773.7 1145.7 1824.9 1116.2 1838.2 1066.4L1928.3 1090.5Z",
    fill: "#9DE34B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.383 -258.027L-244.041 -154.987L-141.001 395.437L409.423 292.397L306.383 -258.027Z",
    fill: "#EA3399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156.2 112.6C-180.8 -19.1003 -94.0002 -145.9 37.6998 -170.5C169.4 -195.2 296.2 -108.4 320.9 23.3997C345.6 155.1 258.8 281.9 127 306.6C-4.70015 331.2 -131.5 244.4 -156.2 112.6Z",
    fill: "#56305B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244 -155L409.5 292.4L-140.9 395.4L-244 -155Z",
    fill: "#CE4353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0009 614.997L-312.975 1010.97L83.0009 1406.95L478.977 1010.97L83.0009 614.997Z",
    fill: "#F7CE45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.2 860.2C15.7 777.3 150.2 777.3 233.1 860.2C316 943.1 316 1077.6 233.1 1160.5C150.2 1243.4 15.7 1243.4 -67.2 1160.5C-150.1 1077.6 -150.1 943.1 -67.2 860.2Z",
    fill: "#E38A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.9002 861.1L233.4 1161.4C150.5 1244.3 15.9998 1244.3 -66.9002 1161.4C-149.8 1078.5 -149.8 944 -66.9002 861.1Z",
    fill: "#FCEF4F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white_bg.c6b48b2c3e2f2e77701b2ddc2917441d.svg";